import { render, staticRenderFns } from "./InvestmentDocumentDropoffForm.vue?vue&type=template&id=010f6258"
import script from "./InvestmentDocumentDropoffForm.vue?vue&type=script&lang=js"
export * from "./InvestmentDocumentDropoffForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports